import { types, flow, applySnapshot } from 'mobx-state-tree';

import { makeRequest, errorResponse, navigate, url } from 'js/services/Network';
import { castEventToValue } from 'js/services/FormTools';
import analytics from 'js/services/Analytics';
import Address from '../types/Address';

export default types
  .model('ReturnOrderPage', {
    modalIsOpen: false,
    isReturning: false,
    error: types.maybeNull(types.string),
    uid: '',
    seller: '',
    pickup: types.maybe(Address),
    item_image: '',
    item_title: '',
    item_alias: '',
    item_mode: '',
    shipping_price: 0,
    shipper_label: '',
    requires_drop_off: true,
    reason: 'default',
  })
  .actions(self => ({
    load: flow(function* load() {
      applySnapshot(self, (yield makeRequest('return-order-data', self)).data);
      //analytics.page('order return page');
    }),
    returnOrder: flow(function* returnOrder(event, values) {
      let response;

      if (!self.isReturning) {
        self.isReturning = true;
        try {
          response = yield makeRequest('return-order', self, values);

          navigate(
            url('status-page', {
              alias: self.item_alias,
            }),
          );
        } catch (error) {
          self.error = errorResponse(error);
        }
        self.isReturning = false;
      }

      return response;
    }),
    showModal() {
      self.reason = 'default';
      self.modalIsOpen = true;
    },
    closeModal() {
      self.modalIsOpen = false;
    },
    setReason(reason) {
      self.reason = castEventToValue(reason);
    },
  }));
